






































import { Component } from "vue-property-decorator";
import UserOnline from "@/app/components/userOnline/userOnline.component.vue";
import { mixins } from "vue-class-component";
import FloatMenuAnimation from "@/resources/mixins/animations/floatMenuAnimation";
import { ClickOutsideDirective } from "@/helpers/directives/clickOutside.directive";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import { MEETING_TYPE } from "../../../../resources/constants/meeting";
import user from "@/store/modules/user";

@Component({
  name: "users-in-call-component",
  components: { UserOnline },
  directives: { ClickOutsideDirective },
})
export default class UsersInCallComponent extends mixins(FloatMenuAnimation) {
  search = "";
  lastScroll = 0;
  loading = false;
  userSearch = [];
  searchTimeOut = null;
  page = 2;
  lastPage = 3;
  scrollEvent = null;
  get usersInCall(): Array<SpaceUserInterface> | [] {
    const userSpaces = this.$store.getters["SpaceStore/getUsersInDraw"];
    const users =
      this.search === ""
        ? this.$store.getters["MeetingStore/getUsersInCall"]
        : this.userSearch;
    setTimeout(() => {
      if (users.length > 0 && !this.scrollEvent) this.onScrollEvent();
    }, 500);
    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    let usersMap = [];
    if (users.length <= 0) return [];
    if (meetingType === MEETING_TYPE.WEBINAR && this.isMultiWebinar) {
      usersMap = users?.map((a) => {
        return { ...a, enabled: true };
      });
    } else if (meetingType === MEETING_TYPE.WEBINAR && !this.isMultiWebinar) {
      usersMap = users?.map((a) => {
        return { ...a, user: a.superSpaceUser?.user, enabled: true };
      });
    } else {
      try {
        usersMap = users.map((a) => {
          return {
            ...a.superSpaceUser,
            user: a.superSpaceUser.user,
            enabled: true,
            spaceUser: a,
          };
          //return userSpaces.filter((b) => b.user.id === a.id)[0];
        });
      } catch (error) {
        // console.log("Error usersInCall ", error);
      }
    }
    // usersMap = usersMap.sort(
    //   (a, b) =>
    //     a.user.name
    //       .normalize("NFD")
    //       .replace(/[\u0300-\u036f]/g, "")
    //       .toLowerCase() -
    //     b.user.name
    //       .normalize("NFD")
    //       .replace(/[\u0300-\u036f]/g, "")
    //       .toLowerCase()
    // );
    // try {
    //   usersMap = usersMap.sort(
    //     (a, b) => b.spaceUser.isWebinarHost - a.spaceUser.isWebinarHost
    //   );
    // } catch (error) {
    //   // do nothing
    // }
    return usersMap;
  }
  get userSpace() {
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    return {
      ...spaceUser.superSpaceUser,
      user: spaceUser.superSpaceUser.user,
      spaceUser: spaceUser,
    };
    /*return {
      connectionStatus: spaceUser.superSpaceUser.connectionStatus,
      enabled: spaceUser.superSpaceUser.enabled,
      id: spaceUser.superSpaceUser.id,
      user: {
        availableStatus: spaceUser.superSpaceUser.user.availableStatus,
        availableStatusReason:
          spaceUser.superSpaceUser.user.availableStatusReason,
        id: spaceUser.superSpaceUser.user.id,
        lastName: spaceUser.superSpaceUser.user.lastName,
        name: spaceUser.superSpaceUser.user.name,
        profileImage: spaceUser.superSpaceUser.user.profileImage,
        timezone: spaceUser.superSpaceUser.user.timezone,
      },
    };*/
  }
  get isMultiWebinar(): boolean {
    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    const space = this.$store.getters["SpaceStore/getSpace"];
    return (
      meetingType === MEETING_TYPE.WEBINAR &&
      space.superSpace.isMultiWebinarActivated
    );
  }

  get disabledLoader(): boolean {
    return this.page > this.lastPage;
  }

  close(): void {
    const menu = document.getElementById("users-in-call-container");
    this.page = 2;
    if (menu.style.display === "block") this.closeUsersInCall();
  }
  onSearch(): void {
    const space = this.$store.getters["SpaceStore/getSpace"];
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    this.loading = true;
    if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      if (this.isMultiWebinar) {
        this.$store.dispatch(
          "SuperSpaceStore/getSuperSpaceUsersInMultiWebinarAction",
          {
            superSpaceId: space.superSpace.id,
            page: 1,
            search: this.search !== "" ? `&search=${this.search}` : "",
            callback: (response) => {
              this.loading = false;
              this.userSearch = response.data;
            },
          }
        );
      } else {
        this.$store.dispatch("SpaceUserStore/getSpaceUsersInWebinarAction", {
          roomId,
          page: 1,
          search: this.search !== "" ? `&search=${this.search}` : "",
          callback: (response) => {
            this.loading = false;
            this.userSearch = response.data;
          },
        });
      }
    }, 1000);
  }
  getMoreUsersInWebinar() {
    this.loading = true;
    const space = this.$store.getters["SpaceStore/getSpace"];
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    if (this.page <= this.lastPage) {
      if (this.isMultiWebinar) {
        this.$store.dispatch(
          "SuperSpaceStore/getSuperSpaceUsersInMultiWebinarAction",
          {
            superSpaceId: space.superSpace.id,
            page: this.page,
            search: "",
            callback: (response) => {
              this.page += 1;
              document.getElementById("users-call-list").scrollTop =
                document.getElementById("users-call-list").scrollHeight - 800;
              this.lastPage = response.headers["pagination-last-page"];
              this.loading = false;
              const users = this.$store.getters["MeetingStore/getUsersInCall"];
              this.$store.dispatch("MeetingStore/setUsersInCallAction", [
                ...users,
                ...response.data,
              ]);
            },
          }
        );
      } else {
        this.$store.dispatch("SpaceUserStore/getSpaceUsersInWebinarAction", {
          roomId,
          page: this.page,
          search: "",
          callback: (response) => {
            this.page += 1;
            document.getElementById("users-call-list").scrollTop =
              document.getElementById("users-call-list").scrollHeight - 800;
            this.lastPage = response.headers["pagination-last-page"];
            this.loading = false;
            const users = this.$store.getters["MeetingStore/getUsersInCall"];
            this.$store.dispatch("MeetingStore/setUsersInCallAction", [
              ...users,
              ...response.data,
            ]);
          },
        });
      }
    }
  }
  onScrollEvent() {
    const openChat = document.getElementById("users-call-list");
    if (openChat)
      this.scrollEvent = openChat.addEventListener("scroll", () => {
        const a = openChat.scrollTop;
        const b = openChat.scrollHeight - openChat.clientHeight;
        if (this.lastScroll < 0.6 && a / b > 0.6) {
          if (!this.loading) {
            if (this.page <= this.lastPage) {
              this.loading = true;
              this.getMoreUsersInWebinar();
            }
          }
        }
      });
  }
}
